<template>
  <div class="product-reference-results mt-6">
    <div class="grid-row lightGrey">
      <!-- headers -->
      <div
        v-for="header in renderingMapping"
        :key="header.value"
        class="grid-row__header">
        {{ header.text }}
      </div>
    </div>

    <div class="product-reference-results__rows">
      <!-- rows -->
      <div
        v-for="item in items"
        :id="item.id"
        :key="item.id"
        v-intersect.once="onIntersect"
        class="grid-row pointer"
        @click="$emit('addToSelected', item)">
        <!-- product type -->
        <div
          class="grid-row__merged-cell">
          <ProductType
            :types="item.productType"
            orientation="row" />
        </div>

        <!-- fields -->
        <template v-for="header in renderingMapping">
          <ProductThumbnail
            v-if="header.value === 'attachment'"
            :key="`${item.id}__${header.value}`"
            :items="[item]"
            :item="item"
            :attachment="item.attachment" />
          <div
            v-else
            :key="`${item.id}__${header.value}`">
            {{ item[header.value] }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductCellFieldProductAutocompleteResults',
  components: {
    ProductThumbnail: () => import('@/components/Product/ProductThumbnail'),
    ProductType: () => import('@/components/App/AppListingElements/AppListingBlockElement/BlockElement/ElementProductType'),
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      renderingMapping: [
        {
          text: '', value: 'attachment', width: 100,
        },
        {
          text: 'Manufacturer', value: 'manufacturer', width: 100,
        },
        {
          text: 'Model', value: 'model', width: 100,
        },
        {
          text: 'Description', value: 'shortDescription', width: 200,
        },
        {
          text: 'Collection', value: 'collectionName', width: 100,
        },
      ],
    };
  },
  computed: {
  },
  methods: {
    onIntersect(entries, observer, isIntersecting) {
      this.$emit('onIntersect', {
        entries,
        observer,
        isIntersecting,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.product-reference-results {
  display: flex;
  flex-direction: column;

  &__rows {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
  }

  .grid-row {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 2fr 1fr;
    gap: 12px;
    padding-block: 12px;
    border-bottom: 1px solid var(--v-darkGrey-base);

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background: var(--v-lightGrey-base);
    }

    &__header {
      background: var(--v-lightGrey-base);
      font-weight: bold;
      font-size: 14px;
    }

    &__merged-cell {
      grid-column: 1 / -1;
    }
  }
}
</style>
